import type { FaireProductEntity } from "../../entity_types/product";

export const p_h5s45raar8: FaireProductEntity = {
  token: "p_h5s45raar8",
  type: "product",
  name: "Polished Gemstone Yellow Jade Tiny Ducks",
  brandToken: "b_q8ypma3xp2",
  brandName: "Superior Stones & Gifts INTL LLP",
  imageUrl:
    "https://cdn.faire.com/fastly/49970cf8b804c2c2d23757d963c99ba5cc3ab360b3bea6e2ee52f4b257ddd415.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/187fe7a09ea16c8be0ad1822067224ab11c1182c76680a42d988fc4c9e7992dd.jpeg",
    "https://cdn.faire.com/fastly/d248b7695a8677d7060d629e0e07ef070b8c7150febf11c0d9469df2145964c6.jpeg",
  ],
  priceDollars: 6,
  description:
    "\nThese tiny ducks made of polished yellow jade will add some quirk to your home decor. Perfect for those who love all things cute and playful, these ducks will bring a smile to your face every time you see them. A fun and unique addition to any space!\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:06.622Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
